export default "__VITE_ASSET__cADWOOWP__"